import { Typography } from "@mui/material";
import ObjectsTable from "./ObjectsTable";
import { useSelector } from "react-redux";
import { buildColumnDefinitionsFromMetaData } from "../../../utilitiesOfBrandConfig/helperOfBrandConfig";

const ObjectsSection = () => {
  const objectSectionMetaData = useSelector(
    (state: any) => state.brandConfigurationReport.objectSectionMetaData,
  );

  // const columnDefs = objectSectionMetaData
  //   ? buildColumnDefinitionsFromMetaData(objectSectionMetaData)
  //   : [];

  //if order is empty then hide the column based on requirement
  const columnDefs = objectSectionMetaData
    ? buildColumnDefinitionsFromMetaData(objectSectionMetaData).filter(
        (col) => objectSectionMetaData[col.key]?.order?.trim() !== "",
      )
    : [];

  return (
    <>
      <Typography px={2} py={1} variant="h6">
        Objects
      </Typography>
      <ObjectsTable columnDefs={columnDefs} />
    </>
  );
};

export default ObjectsSection;
